import { BaseService } from '@/modules/Core/services/BaseService'
import type { IAlertAlertas, IAlertAlertasGenerales } from '@/modules/Asistencial/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { ITrazabilidadRuta } from '@/modules/DemandaInducida/interfaces/ITrazabilidadRuta'

export class AlertasService extends BaseService<IAlertAlertas> {
  constructor() {
    super({
      baseUrl: 'scheduling/alerts/'
    })
  }

  async generales(): Promise<AxiosResponse<IResponseApi<IAlertAlertasGenerales>>> {
    return this.http.get<IResponseApi<IAlertAlertasGenerales>>(`/general`)
  }

  async trazabilidadRuta(cittId: number): Promise<AxiosResponse<IResponseApi<ITrazabilidadRuta>>> {
    return this.http.get<IResponseApi<ITrazabilidadRuta>>('route-traceability', {
      params: { cittId }
    })
  }

  async cierreFormulario(
    alerId: number,
    payload: { cittId: number; formData: Array<{ name: string; value: string; label?: string; typeComponent?: string; searchValue?: string }> }
  ): Promise<AxiosResponse<IResponseApi<{ alerId: number; cttaId: number; cittId: number }>>> {
    return this.http.post<IResponseApi<{ alerId: number; cttaId: number; cittId: number }>>(
      `/cierre-formulario/${alerId}`,
      payload
    ).catch(error => this.errorHandle(error))
  }
}

export const alertasService = new AlertasService()
